import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { dateCompare } from "jsFunctions/dateTimeFormat";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";

const RefundAmountTable = ({ currentRefundInfo, editRefundInfo, type }) => {
    return (

        type === 'current' ?
        <div className="info-table change-modal-table">
                  <Table size="md" className="table-info" w='100'>
                    <Thead>
                      <Tr>
                        <Th>Payee</Th>
                        <Th>Amount</Th>
                        <Th>Bank</Th>
                        <Th>ReferenceNo</Th>
                        <Th>Date</Th>

                      </Tr>
                    </Thead>
                    <Tbody>
                    {editRefundInfo?.map((item,index) => {
                    return (
                      <Tr>
                        <Td className={`${item?.pyId?._id !== currentRefundInfo[index]?.pyId?._id  ? 'data_compare_red' : '' }`}>{item?.pyId?.val}</Td>
                        <Td className={`${item?.amt !== currentRefundInfo[index]?.amt  ? 'data_compare_red' : '' }`}>{formatAmountInINR(parseFloat(item?.amt || 0))}</Td>
                          <Td className={`${item?.bnkId?._id !== currentRefundInfo[index]?.bnkId?._id  ? 'data_compare_red' : '' }`}>{item?.bnkId?.val}</Td>
                          <Td className={`${item?.refNo !== currentRefundInfo[index]?.refNo  ? 'data_compare_red' : '' }`}>{item?.refNo}</Td>

                        <Td className={`${!dateCompare(dateTimeFormat(item?.pmtDt) ,dateTimeFormat(currentRefundInfo[index]?.pmtDt))  ? 'data_compare_red ' : '' }`}>{dateTimeFormat(item?.pmtDt)}</Td>

                      </Tr>

                    );
                  })}
                    </Tbody>
                  </Table>
                   
                  </div>

            :
            <div className="info-table change-modal-table">
        <Table size="md" className="table-info" w='100'>
          <Thead>
            <Tr>
              <Th>Payee</Th>
              <Th>Amount</Th>
              <Th>Bank</Th>
              <Th>ReferenceNo</Th>
              <Th>Date</Th>

            </Tr>
          </Thead>
          <Tbody>
          {currentRefundInfo?.map((item,index) => {
          return (
            <Tr>
              <Td className={`${item?.pyId?._id !== editRefundInfo[index]?.pyId?._id  ? 'data_compare_green' : '' }`}>{item?.pyId?.val}</Td>
              <Td className={`${item?.amt !== editRefundInfo[index]?.amt  ? 'data_compare_green' : '' }`}>{formatAmountInINR(parseFloat(item?.amt || 0))}</Td>
                <Td className={`${item?.bnkId?._id !== editRefundInfo[index]?.bnkId?._id  ? 'data_compare_green' : '' }`}>{item?.bnkId?.val}</Td>
                <Td className={`${item?.refNo !== editRefundInfo[index]?.refNo  ? 'data_compare_green' : '' }`}>{item?.refNo}</Td>

              <Td className={`${!dateCompare(dateTimeFormat(item?.pmtDt) ,dateTimeFormat(editRefundInfo[index]?.pmtDt))  ? 'data_compare_green' : '' }`}>{dateTimeFormat(item?.pmtDt)}</Td>

            </Tr>

          );
        })}
          </Tbody>
        </Table>
         
        </div>
    )


}

export default RefundAmountTable;
